import { Font } from "@moneyforward/mfx_biz_react_components";
import { Aritcle } from "@/components/atoms/terms/Article";
import config from "@/libs/config";

/**
 * Props for provider of specified service component
 * @typedef {Object} Props
 * @property {number} articleNumber - The number of the article
 * @property {string} [articleTitle] - The title of the article (optional)
 */
type Props = {
  articleNumber: number;
  articleTitle?: string;
};

/**
 * Component to display provider of specified service
 */
export const ArticleProviderOfSpecifiedService: React.FC<Props> = ({
  articleNumber,
  articleTitle = "指定サービスの提供主体",
}: Props) => {
  return (
    <Aritcle articleNumber={articleNumber} articleTitle={articleTitle}>
      <Font>
        前条各号に定める指定サービスは、当社が利用者に対して提供するものであり、
        {config.BANK_FORMAL_NAME}及び{config.BANK_FORMAL_NAME}の保険代理店は
        Mikatano ID
        利用規約及び指定サービスの利用にあたり利用者に適用される利用規約の当事者とはなりません。
      </Font>
    </Aritcle>
  );
};
